<template>
  <div id="div-with-loading">
    <div class="nothing-to-do indented-section mx-auto">
      <div class="vx-row flex flex-wrap justify-between">
        <div class="radix-logo mx-auto">
          <!-- <img src="../../assets/images/logo/falcon-x-radix.svg" alt="Radix Logo"/> -->
					<img class="ml-2" src="../../assets/images/logo/radix-logo-black.svg" alt="Radix Logo" height="25"/>
        </div>

				<!-- TODO: Add it back when the logos for all partners are added to system -->
        <!-- <div class="partner-logo my-auto">
					<img src="../../assets/images/partner-logos/GoDaddy-Black.png" width="120" height="30" alt="Partner Logo" />
				</div> -->
      </div>

      <div class="vx-row justify-center mt-6">
        <h3 class="text-center">Period: {{ period }}</h3>
      </div>

      <div class="vx-row justify-center mt-4 status-container">
        <vs-chip transparent color="dark" class="custom-bg">
          {{ status }}
        </vs-chip>
      </div>
      
      <div class="vx-row justify-center mt-12">
        <p class="text-center status-update">
          Nothing for you to do at the moment, we will mail you when we have an update.
        </p>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "NothingToDo",
  props: {
    status: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      period: ''
    }
  },
  mounted() {
    this.$axiosSecureClient.get(`/current-period/${localStorage.getItem('loggedInPartnerId')}`)
    .then(response => {
      this.period = response.data.data.previous_range + ' ' + response.data.data.year;
    })
    .catch;
  }
};
</script>